<app-header></app-header>
<div class="tracker-detail pt0">
    <app-step-progress-bar [wizardSteps]="steps" [stepName]="activeStepName" [stepCompleted]="activeStepCompleted"></app-step-progress-bar>
    <div class="container">
        <div class="row">
            <div class="col-sm-12 w100">
                <div class="innercard">
                    <h3 class="font24 clrblue center" style="font-size: 24px;" translate>lblTerms&Conditions</h3>
                    <div class="mt30">
                        <div class="panel panel-default mb20">
                            <div class="panel-body myDiv">
                                <div class="pdlr15 pdtb15">
                                    <div class="termsContainer">
                                        <span translate>lblPrivacyConsent</span><br>
                                        <span translate>lblPriceDeviationConsentText</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="userPrivacy.controls.userPrivacyAccept.invalid && userPrivacy.controls.userPrivacyAccept.touched && f.userPrivacyAccept.errors" class="alert alert-danger">
                        <div *ngIf="f.userPrivacyAccept.errors.required" translate>lblPleaseAcceptTerms&Conditions</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="bottomaction">
    <div class="container">

    <div class="row">


   
    <div class=" col-auto ">
        <form [formGroup]="userPrivacy" class="form">

            <div class="form-group mb-0 mt-2">
                <label class="cstcheckbox flmid fullspace w100 bold font16">
                    <input type="checkbox" name="userPrivacyAccept" formControlName="userPrivacyAccept"
                        id="userPrivacyAccept" class="form-check-input" />
                    <span></span>
                    <abbr translate>lblIAcceptTheT&C's</abbr>
                </label>
            </div>

        </form>
    </div>
    <div class="col-auto ml-auto">
        <button type="submit" class="btn btn-primary minwidth btn-lg m-0" aria-label="Center Align" [disabled]="!f.userPrivacyAccept.value" (click)="userPrivacyFormSubmit()">
            <span translate>lblNext</span>
        </button>
    </div>
    </div>
    </div>
</div>